import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ModalRef } from '@siemens/element-ng/modal';
import { SiIconComponent } from '@siemens/element-ng/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-energy-banner-dialog',
    templateUrl: './energy-banner-dialog.component.html',
    imports: [SiIconComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EnergyBannerDialogComponent {
    private readonly modalRef = inject<ModalRef<EnergyBannerDialogComponent, string>>(ModalRef);

    protected readonly seabUrl = 'https://seab.mx.siemens-energy.cloud/index.html';
    protected readonly contactEmail = 'marco.pinheiro@siemens-energy.com';

    public close(): void {
        this.modalRef.hide('close');
    }
}
